import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IDeepLink } from '../../models/deeplink'

export interface IDeepLinksSlice {
  deeplinks?: IDeepLink[]
}

const initialState: IDeepLinksSlice = {
  deeplinks: []
}

export const deepLinksSlice = createSlice({
  name: 'deeplinks',
  initialState,
  reducers: {
    setDeepLinks: (state, action: PayloadAction<IDeepLink[]>) => {
      state.deeplinks = action.payload
    }
  }
})

export const {
  setDeepLinks
} = deepLinksSlice.actions

export default deepLinksSlice.reducer
